<template>
  <div class="integralManagement">
    <div>
      <div class="orderSearchBox">
        <div class="searchItem">
          <el-input v-model="form.name" placeholder="用户昵称"></el-input>
        </div>
        <div class="searchItem">
          <el-input v-model="form.username" placeholder="用户账号"></el-input>
        </div>
        <el-button class="searchBtn" @click="search">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="resetData">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
      <!-- 排序 -->
      <div class="sorting">
        <el-radio-group v-model="checkboxGroup.radio1" size="small" @change="findInfo">
          <el-radio-button label="totalPoints">
            <p>积分总数</p>
            <i class="el-icon-bottom" v-if="checkboxGroup.radio1 == 'totalPoints'"></i>
            <i class="el-icon-top" v-else></i>
          </el-radio-button>
          <el-radio-button label="totalConsume">
            <p>积分消费</p>
            <i class="el-icon-bottom" v-if="checkboxGroup.radio1 == 'totalConsume'"></i>
            <i class="el-icon-top" v-else></i>
          </el-radio-button>
          <el-radio-button label="points">
            <p>现有积分</p>
            <i class="el-icon-bottom" v-if="checkboxGroup.radio1 == 'points'"></i>
            <i class="el-icon-top" v-else></i>
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="orderListTable">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="tableContent"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="name"
            label="用户昵称"
            header-align="center"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="totalPoints"
            align="center"
            header-align="center"
            label="积分总数"
          >
          </el-table-column>
          <el-table-column
            prop="totalConsume"
            align="center"
            header-align="center"
            label="积分消费"
          >
          </el-table-column>
          <el-table-column
            prop="totalExpired"
            align="center"
            header-align="center"
            label="过期积分"
          >
          </el-table-column>
          <el-table-column
            prop="points"
            align="center"
            header-align="center"
            label="现有积分"
          >
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleIntegralDetails(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          @prev-click="handleCurrentChange"
          @next-click="handleCurrentChange"
          layout="total,prev, pager, next,jumper"
          :current-page="current"
          :page-size="pageSize"
          :total="total"
          class="pagination"
        >
        </el-pagination>
        <el-dialog
          title="查看"
          :close-on-click-modal="false"
          :visible.sync="dialogyDateVisible"
          append-to-body
          class="dialogActivityDateVisible"
        >
          <div class="dialogContent">
            <div class="titleTop">积分信息</div>
            <div class="dialogContent_box">
              <div class="box_mess">
                <p>积分总数：</p>
                <p>{{ totalPoints }}</p>
              </div>
              <div class="box_mess">
                <p>积分消费：</p>
                <p>{{ totalConsume }}</p>
              </div>
              <div class="box_mess">
                <p>过期积分：</p>
                <p>{{ totalExpired }}</p>
              </div>
              <div class="box_mess">
                <p>现有积分：</p>
                <p>{{ points }}</p>
              </div>
            </div>
            <div class="titleTop">积分记录</div>
            <el-table
              :data="tableDataList"
              border
              style="width: 100%"
              class="tableContent"
            >
              <el-table-column
                prop="recordDate"
                label="日期"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="points"
                label="积分数"
                header-align="center"
                show-overflow-tooltip
                align="center"
                :formatter="formatterPoints"
              >
              </el-table-column>
              <el-table-column
                prop="type"
                label="描述"
                header-align="center"
                show-overflow-tooltip
                align="center"
                :formatter="formatterType"
              >
              </el-table-column>
              <el-table-column
                prop="origin"
                label="来源"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
    import {
        userPointsListByPage,
        userPointsRecordListByPage
    } from "../../utils/interface";
export default {
  name: "integralManagement",
  data() {
    return {
        totalPoints:0,
        totalConsume:0,
        totalExpired:0,
        points:0,
        form: {
            name: "",
            username: "",
        },
      tableData: [
      ],
      current: 1,
      pageSize: 10,
      total: 0,
      dialogyDateVisible: false,
      tableDataList: [
      ],
      // 排序
      checkboxGroup: {
          radio1: '0',
      },
    };
  },
    mounted() {
        this.search();
    },
  methods: {
      findInfo(){

        this.form.sorter = this.checkboxGroup.radio1 + "_descend";
        console.log('this.checkboxGroup.radio1',this.checkboxGroup.radio1 );
        this.search();
      },
      formatterPoints(row, column) {
          if(row.type == 'EXPIRED'){
              return "-" + row.points;
          } else if(row.type == 'PLUS'){
              return "+" + row.points;
          } else if(row.type == 'MINUS'){
              return "-" + row.points;
          }
      },
      formatterType(row, column) {
          if(row.type == 'EXPIRED'){
              return "积分过期";
          } else if(row.type == 'PLUS'){
              return "签到";
          } else if(row.type == 'MINUS'){
              return "积分消费";
          }
      },
      search() {
          this.form.current = this.current;
          this.form.pageSize = this.pageSize;
          userPointsListByPage(this.form).then((res)=>{
              if(res) {
                  this.tableData = [];
                  this.total = res.total;
                  this.tableData = res.list
              }
          });
      },
    resetData() {
      this.form.name = "";
      this.form.username = "";
        this.search();
    },
    handleCurrentChange(val) {
        this.current = val
        this.search();
    },
    handleIntegralDetails(val) {
          this.totalPoints = val.totalPoints;
          this.totalConsume = val.totalConsume;
          this.totalExpired = val.totalExpired;
          this.points = val.points;

        userPointsRecordListByPage({userUuid: val.userUuid, current: 1, pageSize: 100000}).then((res)=>{
            if(res.success) {
                this.tableDataList = [];
                this.tableDataList = res.data.list
            }
        });
      this.dialogyDateVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.integralManagement {
  background: #fff;
  margin: 0 20px 20px;
  padding: 20px;

  .orderSearchBox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    /deep/ .el-input {
      width: initial;
      // margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
    }

    .resetBtn {
      color: #333333;
    }
    .searchItem {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .name {
        padding-right: 20px;
        min-width: 100px;
      }
    }
    .searchItem_time {
      margin-right: 20px;
      /deep/.el-input__inner {
        width: 292px;
      }
    }
  }
  .tableContent {
    min-height: 650px;

    /deep/ .el-table__header {
      tr {
        th {
          border-right: none;
        }
      }

      /deep/ .el-table__cell {
        padding: 5px 0;
        background: #f2f5fc;
      }
    }

    /deep/ .el-table__body {
      img {
        vertical-align: middle;
        width: 52px;
        height: 50px;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
        .sorting {
            margin-bottom: 10px;
            font-size: 14px;

            span {
                margin-right: 15px;
            }
                    p {
            margin: 0;
        }
        /deep/.el-radio-button--small .el-radio-button__inner {
           display: flex;
           align-items: center;
        }
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            background-color: #3d7fff;
        }
        }
}
.dialogActivityDateVisible {
  .titleTop {
    font-size: 20px;
    margin-bottom: 26px;
    padding-left: 48px;
    border-top: 1px solid #efefef;
    padding-top: 30px;
    &:nth-of-type(1) {
      border-top: none;
      padding-top: 0;
    }
  }
  .dialogContent_box {
    display: flex;
    flex-wrap: wrap;
    margin: 0 50px;
    .box_mess {
      width: 50%;
      display: flex;
      margin-bottom: 15px;
      img {
        width: 300px;
        height: 150px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/integral/userIntegralManagement.vue